export const socialsData = {
    github: 'https://github.com/saiteja-pro',
    linkedIn: 'https://www.linkedin.com/in/saitejapro/',
    medium: 'https://medium.com/@saitejapro',
    instagram: 'https://www.instagram.com/teja___sai/',
    facebook: 'https://www.facebook.com/teja1508/',
    youtube: 'https://www.youtube.com/@TejaTurn'
}